export default {
  realProperty: 'Недвижимое имущество',
  movableProperty: 'Движимое имущество',
}